// extracted by mini-css-extract-plugin
export default {"title-wrapper":"TreeNodeTitle-module__title-wrapper___xziv9","icon":"TreeNodeTitle-module__icon___gGsnt","title":"TreeNodeTitle-module__title____Rk0g"};